import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Snackbar } from '@mui/material';
import { Formik } from 'formik';
import dayjs from 'dayjs';

import Alert from 'src/components/Alert';
import { CONSTANTS, STRINGS } from 'src/commons';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { addBatch } from 'src/api/batches';
import BatchForm from 'src/components/batches/BatchForm';

const AddBatch = () => {
  const date = dayjs().format('YYYY-MM-DD');
  const { startLoading, stopLoading } = loaderReducerAction;
  const dispatch = useDispatch();
  const { user ,gymId } = useSelector((state) => state.common);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });

  const navigate = useNavigate();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <>
      <Helmet>
        <title>Batches | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginTop: '2rem'
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              name: '',
              start_time: null,
              end_time: null
            }}
            validationSchema={CONSTANTS.batchValidationSchema}
            onSubmit={async (values) => {
              values.start_time = dayjs(date + values.start_time).valueOf();
              values.end_time = dayjs(date + values.end_time).valueOf();
              values.gym_id = gymId
              try {
                dispatch(startLoading());
                const res = await addBatch(user, values);
                dispatch(stopLoading());
                const isError = res.status !== 200;
                const message = isError ? res?.message : "Batch Added Successfully"
                setSnackbarState({
                  open: true,
                  message: res.message,
                  severity: isError ? 'error' : 'success'
                });
                if (!isError) {
                  navigate(CONSTANTS.ROUTES.PRIVATE_ROUTES.BATCHES);
                }
              } catch (err) {
                dispatch(stopLoading());
                setSnackbarState({
                  open: true,
                  message: err.message,
                  severity: 'error'
                });
              }
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldValue,
              isSubmitting,
              touched,
              values
            }) => (
              <BatchForm
                errors={errors}
                handleBlur={handleBlur}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
                isSubmitting={isSubmitting}
                touched={touched}
                values={values}
                heading={STRINGS.ADD_BATCH}
              />
            )}
          </Formik>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarState.open}
            autoHideDuration={3000}
            onClose={handleClose}
          >
            <div>
              <Alert onClose={handleClose} severity={snackbarState.severity}>
                {snackbarState.message}
              </Alert>
            </div>
          </Snackbar>
        </Container>
      </Box>
    </>
  );
};

export default AddBatch;
